import { type FC } from "react"

import { ModalHelpCenter, ModalHelpCenterIcon } from "~/components/Modal"

const HelpCenter: FC = () => (
	<ModalHelpCenter newTab onClick="https://forento.link/create-course">
		<ModalHelpCenterIcon />
		Learn more
	</ModalHelpCenter>
)

export default HelpCenter
